import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "gql/apollo";

export const contactGroupFields = graphql(/* GraphQL */ `
	fragment contactGroupFields on ContactGroup {
		gid
		name
		contactCount
		created
		updated
	}
`);

export const ListContactGroups = graphql(/* GraphQL */ `
	query listContactGroups($params: ListContactGroupsParams!) {
		listContactGroups(params: $params) {
			...contactGroupFields
		}
	}
`);

export const useListContactGroups = (skip: boolean = false) => {
	const { data, loading, error } = useQuery(ListContactGroups, {
		variables: {
			params: {
				count: 50,
			},
		},
		skip,
	});

	const contactGroups =
		getFragmentData(contactGroupFields, data?.listContactGroups) ?? [];

	return {
		contactGroups,
		loading,
		error,
	};
};
